import React from "react"

import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverCloseButton,
  useDisclosure,
  Button,
} from "@chakra-ui/react"

const LearnMoreModal = ({
  triggerTitle = "Learn more",
  triggerFontSize = 14,
  triggerColor = "black",
  title,
  width,
  ml = 0,
  children,
}: {
  triggerTitle?: string
  triggerFontSize?: number
  triggerColor?: string
  title?: string
  width: { base: string; xsm: string; sm: string; md: string }
  ml?: number
  children: React.ReactNode
}) => {
  const { isOpen, onToggle, onClose } = useDisclosure()
  return (
    <Popover isOpen={isOpen} onClose={onClose} placement='bottom-start'>
      <PopoverTrigger>
        <Button
          variant='link'
          fontSize={triggerFontSize}
          fontWeight={500}
          ml={ml}
          color={triggerColor}
          whiteSpace='pre-wrap'
          textAlign='left'
          onClick={onToggle}
        >
          {triggerTitle}
        </Button>
      </PopoverTrigger>
      <PopoverContent
        width={width}
        padding={{ base: 2, sm: 6 }}
        borderRadius='25px'
        boxShadow='-1px 4px 12px rgba(0, 0, 0, 0.16)'
      >
        {title && (
          <PopoverHeader
            borderBottomWidth='0px'
            pb={2}
            fontSize={{ base: 18, sm: 20 }}
            fontWeight={500}
          >
            {title}
          </PopoverHeader>
        )}
        <PopoverCloseButton
          fontSize={{ base: 12, sm: 14 }}
          padding={{ base: 3, sm: 5 }}
        />
        <PopoverBody>{children}</PopoverBody>
      </PopoverContent>
    </Popover>
  )
}

export default LearnMoreModal
